import { EntityWithUser } from "@common/types/entity";
import { FinancialAccount } from "@common/types/financialAccount";
import { WorkspaceMember } from "@common/types/workspace";
import { AccountsTableRow } from "./accountsView.types";

interface EntityContextWithAccounts {
    entity: EntityWithUser;
    financialAccounts: FinancialAccount[];
}

function getAssignedMembersForEntity(
    members: WorkspaceMember[],
    entityId: number,
): WorkspaceMember[] {
    return members.filter((member) =>
        member.entityAssignments.some(
            (assignment) => assignment.entity.id === entityId,
        ),
    );
}

interface BuildAccountsTableDataParams {
    entitiesContext?: EntityContextWithAccounts[];
    workspaceMembers?: WorkspaceMember[];
}

export function buildAccountsTableData({
    entitiesContext,
    workspaceMembers,
}: BuildAccountsTableDataParams): AccountsTableRow[] {
    return (entitiesContext ?? [])
        .filter(
            // hide "Other entities" entity if it has no accounts
            (entityContext) =>
                !entityContext.entity.isMockEntity ||
                entityContext.financialAccounts.length > 0,
        )
        .map((entityContext) => {
            const entityAssignedMembers = getAssignedMembersForEntity(
                workspaceMembers ?? [],
                entityContext.entity.id,
            );

            const accounts: AccountsTableRow[] =
                entityContext.financialAccounts.map((account) => ({
                    id: `account-${account.id}`,
                    entity: entityContext.entity,
                    account,
                    assignedMembers: [],
                    accounts: [],
                }));

            return {
                id: `entity-${entityContext.entity.id}`,
                entity: entityContext.entity,
                assignedMembers: entityAssignedMembers,
                accounts,
            };
        });
}
